import { render } from "./OwnerDashboard.vue?vue&type=template&id=34f5fb7c&scoped=true"
import script from "./OwnerDashboard.vue?vue&type=script&lang=js"
export * from "./OwnerDashboard.vue?vue&type=script&lang=js"

import "./OwnerDashboard.vue?vue&type=style&index=0&id=34f5fb7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f5fb7c"]])

export default __exports__